import { ICreateTermoUseCase } from "../../../presentation/useCases/create/create_termo_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateTermoUseCase
 */

export class CreateTermoUseCase implements ICreateTermoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    codigo?: string,
    descricao?: string,
    nome?: string
  ): Promise<number> {

    return this.repository.createTermo(codigo, descricao, nome);
  }
}
